// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();
$(window).scroll(function(event){
  	didScroll = true;
});
setInterval(function() {
    if (didScroll) {
      	hasScrolled();
      	didScroll = false;
    }
}, 250);
function hasScrolled() {
    var st = $(this).scrollTop();
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
      	return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
      	// Scroll Down
      	$('.wrapper > header').removeClass('navDown').addClass('navUp');
    } else {
      	// Scroll Up
      	if(st + $(window).height() < $(document).height()) {
        	$('.wrapper > header').removeClass('navUp').addClass('navDown');
      	}
    }
    lastScrollTop = st;
}
$(window).resize(function(event){ $('.wrapper > header').addClass('navDown');});

$(document).ready(function() {

	$("#video-toggler").on("click", function(){
		var video = jQuery('#demoVid');
		$.featherlight('#video-lightbox', {
			afterOpen: function (event) {
              	video.muted= true;
				video[0].play();
				$("video").attr("controls", true);
              	$("video").prop("muted", true);
				$("vjs-cntrol-bar").hide();
			}
		});
	});

	$("#video-toggler-potter").on("click", function(){
		var videoPotter = jQuery('#potterVid');
		$.featherlight('#video-lightbox', {
			afterOpen: function (event) {
              	$('#potterVid')[0].play();
				videoPotter.attr("controls", true);
              	videoPotter.prop("muted", false);
				$("vjs-cntrol-bar").hide();
			}
		});
	});
  
  	$("#nextSlide").on("click", function(){
		$('#nextSlide').animate({opacity: 0}, function() {
        	$(this).remove();
    	});
	});
 	$("#nextSlide").click(function() {
    	$([document.documentElement, document.body]).animate({
        	scrollTop: $("#meetBackShield").offset().top
    	}, 1000);
	});
  	/*
    // Instantiate EasyZoom instances
    var $easyzoom = $('.easyzoom').easyZoom();
    // Setup thumbnails example
    var api1 = $easyzoom.filter('.easyzoom--with-thumbnails').data('easyZoom');
    $('.thumbnails').on('click', 'a', function(e) {
        var $this = $(this);
        e.preventDefault();
        // Use EasyZoom's `swap` method
        api1.swap($this.data('standard'), $this.attr('href'));
    });
  	*/
	// Add smooth scrolling to all hash links
  	/*
	$("a").on('click', function(event) {
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			$('html, body').animate({
				scrollTop: jQuery(hash).offset().top
			}, 800, function() {
				//window.location.hash = hash;
			});
		}
	});
    */

	// MailChimp Ajax Form
	ajaxMailChimpForm(jQuery("#subscribe-form"), jQuery("#subscribe-result"));

	function ajaxMailChimpForm($form, $resultElement) {
		$form.submit(function(e) {
			e.preventDefault();
			if (!isValidEmail($form)) {
				var error = "A valid email address must be provided.";
				$resultElement.html(error);
				$resultElement.css("color", "white");
			} else {
				$resultElement.css("color", "white");
				$resultElement.html("Subscribing...");
				submitSubscribeForm($form, $resultElement);
			}
		});
	}

	function isValidEmail($form) {
		var email = $form.find("input[type='email']").val();
		if (!email || !email.length) {
			return false;
		} else if (email.indexOf("@") == -1) {
			return false;
		}
		return true;
	}

	function submitSubscribeForm($form, $resultElement) {
		$.ajax({
			type: "GET",
			url: $form.attr("action"),
			data: $form.serialize(),
			cache: false,
			dataType: "jsonp",
			jsonp: "c",
			contentType: "application/json; charset=utf-8",
			error: function(error) {
				// According to jquery docs, this is never called for cross-domain JSONP requests
			},
			success: function(data) {
				if (data.result != "success") {
					var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
					$resultElement.css("color", "white");
					if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
						message = "You're already subscribed. Thank you.";
						$resultElement.css("color", "white");
					}
					$resultElement.html(message);
				} else {
					$resultElement.css("color", "white");
					$resultElement.html("<div class='thanksContainer'><h2>We'd like to thank you.</h2><h3>(Your back will too.)</h3><p>Thanks for signing up for the BackShield mailing list. You will receive an email for you to confirm your subscription. We'll let you know when BackShield is available for purchase this September. When it's time to order, we'll send you information for a 20 percent discount on your first BackShield.</p><p>Thanks again for your interest. Back-friendly driving is just around the corner.</p><p>Sincerely,<br />The BackShield Team</p></div>");
				}
			}
		});
	}
});

(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);
	var $body = $(document.body);
	var $classes = {
		FsrImage: 'image-full',
		FsrHolder: 'fsr-holder',
		Hover: 'hover',
		Active: 'active',
		ShowNavMain: 'show-nav-main',
		SliderContainer: 'ul.slides',
		IsConfirm: 'is-confirm',
		Wrapper: 'wrapper'
	};

	var $slider = [];
	var _isDesktop = false;
	var _isMobile = false;
	var _isTablet = false;
	var _currentSection = 0;
	var _windowHeight = 0;

	$doc.ready(function() {

		$body = $('body');
		//$body.InitClick();
		$body.viewport();

		$('.nav-trigger').on('touchstart click', function(event) {
			$(this).toggleClass('active')
			$('body').toggleClass('nav-show')

			event.preventDefault();
		});

		$('.qty-wrapper').find('span').on('touchstart click', function() {
			var $this = $(this);
			var qtyInput = $this.parent().find('input');
			var qtyInputVal = qtyInput.val();
			qtyInputVal = ($.isNumeric(qtyInputVal)) ? qtyInputVal : 0;

			if ($this.hasClass('qty-plus')) {
				qtyInputVal++;
				qtyInputVal = (qtyInputVal < 0) ? 1 : qtyInputVal;
				qtyInput.val(qtyInputVal)
			} else {
				qtyInputVal--;
				qtyInputVal = (qtyInputVal < 0) ? 0 : qtyInputVal;
				qtyInput.val(qtyInputVal);
			}
		})

		$win.on('scroll', function() {
			var scrollTop = $win.scrollTop();
			if (scrollTop > 50) {
				$('.header').addClass('fixed')
			} else {
				$('.header').removeClass('fixed')
			}
		});

		$fullpage = $('#fullpage');
		$fullpageNav = $('#fullpage-nav');
		$body = $('body');
		$slider['splash'] = $('.slider-splash');
		$('.' + $classes.FsrImage).fullscreener({
			parentClass: $classes.FsrHolder
		});
		//$body.InitClick();
		$body.viewport();
		$('.nav-trigger').on('click', function(event) {
			$(this).toggleClass('active')
			$('body').toggleClass('nav-show')
			event.preventDefault();
		});
		$('nav.nav a').on('touchstart click', function(event) {
			$('.nav-trigger').toggleClass('active')
			$('body').toggleClass('nav-show')
		});
		initSliderGallery();
		initSliderMain();
	});

/*
	$.fn.InitClick = function() {
		$body.on('click touchstart', function(event) {
			$target = $(event.target);

			if (_isTablet || _isMobile) {
				if (!$target.parents('.nav').length) {
					$('.nav li').removeClass($classes.Hover);
				}
			}
		});

		$('.nav a').click(function(event) {
			if (_isTablet || _isMobile) {
				var $this = $(this);
				var $parent = $this.parent();

				if ($parent.find('> ul').length && !$parent.hasClass($classes.Hover)) {
					event.preventDefault();
					$parent.addClass($classes.Hover).siblings().removeClass($classes.Hover);
				}
			}
		});
	}
*/
	$.fn.viewport = function() {
		var _deviceWidth = $win.width();
		_isDesktop = (_deviceWidth > 1024) ? true : false;
		_isMobile = (_deviceWidth <= 767) ? true : false;
		_isTablet = (_deviceWidth <= 1024 && _deviceWidth >= 768) ? true : false;
	}

	$win.load(function() {
		$body.InitSlider();

	});

	$win.on('resize orientationcgange', function() {
		$body.viewport();
		$body.InitSlider();
	});

	function initSliderGallery() {
		var $paging = $('.slider-paging .slider-paging-numbers');
		var $gallery = $('.slider-gallery .slides');
		$gallery.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
			var i = (currentSlide ? currentSlide : 0) + 1;
			$paging.text(i + ' of ' + slick.slideCount);
		});
		$gallery.slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			responsive: [{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false
				}
			}]
		});
	}

	function initSliderMain() {
		var $galleryMain = $('.slider-main .slides');
		$galleryMain.slick({
			dots: false,
			arrows: false,
			fade: true,
			cssEase: 'linear',
			infinite: true,
			speed: 500,
			slidesToShow: 1
		});
	}

	$.fn.fullscreener = function(options) {
		$(this).each(function() {
			var $this = $(this);

			$this.parent().addClass(options.parentClass).attr('style', 'background-image: url(' + $this.attr('src') + ');');
		});
	}

	$.fn.viewport = function() {
		var _deviceWidth = $win.width();

		_isDesktop = (_deviceWidth > 1024) ? true : false;
		_isMobile = (_deviceWidth <= 767) ? true : false;
		_isTablet = (_deviceWidth <= 1024 && _deviceWidth >= 768) ? true : false;
	}

	$.fn.InitSlider = function() {
		if ($slider['splash'].length) {
			$slider['splash'].find($classes.SliderContainer).carouFredSel({
				auto: 6000,
				responsive: true,
				items: {
					visible: 1
				},
				scroll: {
					items: 1,
					fx: 'crossfade',
					duration: 1000
				}
			});
		}
	}
})(jQuery, window, document);